import { useEffect } from 'react';

export function useBeforeUnloadEvent(rejectCondition: boolean) {
  useEffect(() => {
    const handleBeforeUnload: EventListener = (event) => {
      if (rejectCondition) {
        return;
      }

      // 이벤트에 대한 메시지를 지정
      const confirmationMessage = '변경사항이 저장되지 않을 수 있습니다. 페이지를 떠나시겠습니까?';

      // 최신 버전의 브라우저에서는 이벤트에 대한 메시지를 반환하여 표시
      event.returnValue = true;

      return confirmationMessage;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [rejectCondition]);
}
